/**
 * Created by cz on 2020/5/6.
 */
/**
 * Created by cz on 2019/7/4.
 */
// 时间补位
let doubleNumber = value => {
  if (value.toString().length < 2) {
    return '0' + value
  } else {
    return value
  }
}

// 日期+时间-格式
let dateTimeFormat = value => {
  if (value) {
    let date = new Date(value)
    let year = date.getFullYear()
    let month = doubleNumber(date.getMonth() + 1)
    let day = doubleNumber(date.getDate())
    let hour = doubleNumber(date.getHours())
    let minu = doubleNumber(date.getMinutes())
    let seco = doubleNumber(date.getSeconds())
    return year + '-' + month + '-' + day + ' ' + hour + ':' + minu + ':' + seco
  } else {
    return ''
  }
}

// 日期-格式
let dateFormat = value => {
  if (value) {
    let date = new Date(value)
    let year = date.getFullYear()
    let month = doubleNumber(date.getMonth() + 1)
    let day = doubleNumber(date.getDate())
    return year + '-' + month + '-' + day
  } else {
    return ''
  }
}

// 获取整数部分
let getInteger = value => {
  return Math.floor(parseFloat(value))
}

// 获取小数部分
let getFloat = value => {
  let float = parseFloat(parseFloat(value) - Math.floor(parseFloat(value))).toFixed(2).substr(1)
  if (float.length === 2) {
    float += '0'
  }
  return float
}

export {
  dateTimeFormat,
  dateFormat,
  getInteger,
  getFloat
}



// WEBPACK FOOTER //
// ./src/common/filters.js